<header>
  <noda-nav-logo />
  <noda-language-switcher />
  <!-- Refactor and remove 5th line after done https://nodapay.atlassian.net/browse/WEB-1734 task -->
  <div class="hidden-menu" nodaMenuToggle></div>
</header>
